import Overview from './overview.vue';
import MobOverview from '@rebuild/materials/shared/customs_calendar/mobile/MobOverviewIndex.vue';
import MobFull from '@rebuild/materials/shared/customs_calendar/mobile/FullIndex.vue';

export const componentMap = {
	overview: Overview,
	'mob-overview': MobOverview,
	'mob-full': MobFull
}; 